import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { getProducts } from '../api/woocommerce';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);

  const loadProducts = useCallback(async (pageNum = 1, reset = false) => {
    setLoading(true);
    try {
      const data = await getProducts({ search: query, perPage: 12, page: pageNum });
      setHasMore(data.length === 12);
      setProducts(prev => reset ? data : [...prev, ...data]);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [query]);

  useEffect(() => {
    setPage(1);
    if (query) loadProducts(1, true);
    else { setProducts([]); setLoading(false); }
  }, [query, loadProducts]);

  return (
    <>
      <style>{`
        .search-page-hero { position: relative; background: #000; padding: 160px 138px 50px; }
        .search-page-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 64px; color: #fff; margin: 0 0 8px; }
        .search-page-sub { font-family: 'Roboto',sans-serif; font-weight: 300; font-size: 18px; color: rgba(255,255,255,0.65); margin: 0; }
        .search-page-section { background: #000; padding: 0 0 80px; }
        .search-page-grid { display: grid; grid-template-columns: repeat(4,1fr); margin: 0 138px; background: #000; gap: 12px; }
        .search-page-load-more { display: block; width: calc(100% - 276px); margin: 36px 138px 0; background: #d71921; color: #fff; font-family: 'Alumni Sans',sans-serif; font-weight: 600; font-size: 20px; padding: 16px; cursor: pointer; border: none; text-align: center; transition: opacity 0.2s; }
        .search-page-load-more:hover { opacity: 0.85; }
        .search-page-loading, .search-page-empty { text-align: center; padding: 80px 20px; font-family: 'Alumni Sans',sans-serif; font-size: 22px; color: rgba(255,255,255,0.4); }

        @media (max-width: 1300px) {
          .search-page-hero { padding: 140px 80px 40px; }
          .search-page-title { font-size: 48px; }
        }
        @media (max-width: 1100px) {
          .search-page-hero { padding: 130px 60px 30px; }
          .search-page-grid { grid-template-columns: repeat(3,1fr); margin: 0 60px; }
          .search-page-load-more { width: calc(100% - 120px); margin: 28px 60px 0; }
        }
        @media (max-width: 900px) {
          .search-page-hero { padding: 130px 20px 24px; }
          .search-page-title { font-size: 36px; }
          .search-page-grid { grid-template-columns: repeat(2,1fr); margin: 0 20px; }
          .search-page-load-more { width: calc(100% - 40px); margin: 24px 20px 0; }
        }
        @media (max-width: 500px) {
          .search-page-grid { grid-template-columns: 1fr 1fr; margin: 0 10px; }
          .search-page-load-more { width: calc(100% - 20px); margin: 20px 10px 0; }
        }
      `}</style>

      <section className="search-page-hero">
        <Navbar />
        <h1 className="search-page-title">Risultati di ricerca</h1>
        <p className="search-page-sub">
          {query ? <>Risultati per &laquo;{query}&raquo;</> : 'Inserisci un termine di ricerca.'}
        </p>
      </section>

      <section className="search-page-section">
        {loading && products.length === 0 ? (
          <div className="search-page-loading">Caricamento prodotti...</div>
        ) : products.length === 0 ? (
          <div className="search-page-empty">Nessun prodotto trovato.</div>
        ) : (
          <>
            <div className="search-page-grid">
              {products.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
            {hasMore && (
              <button
                className="search-page-load-more"
                onClick={() => { const n = page + 1; setPage(n); loadProducts(n, false); }}
              >
                {loading ? 'Caricamento...' : 'Carica altri prodotti'}
              </button>
            )}
          </>
        )}
      </section>

      <Footer />
    </>
  );
}
